/* eslint-disable @typescript-eslint/no-explicit-any */
import { IPermission, IRole, createPermissionLevel } from '@rhybus/api/dist/rhybus'

import { mpfAuthCrudHttp } from '../../assets/ts/api/mpf-auth-crud-http'
import * as CPTSRoles from './roles-test-data.json'
import * as secGroups from './security-groups'

function ReturnRolePermission(roleType: any) {
  switch (roleType) {
    case 'appAdmin':
      return appAdmin
    case 'appUser':
      return appUser
    case 'appPrivilegeHigh':
      return appPrivilegeHigh
    case 'appPrivilegeMedium':
      return appPrivilegeMedium
    default:
      return appUser
  }
}

// Admin, Customer Portal Owner, MPF Owners
const appAdmin: IPermission[] = [
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.METADATA_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.CONTENT_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.APPLICATION_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.USERSTORE_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.VIEW_SECURITY_GROUP,
  },
]

// Customer, Technician, supervisor, CSS
const appUser: IPermission[] = [
  {
    permissionLevel: createPermissionLevel(true, false, false),
    securityGroup: secGroups.METADATA_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, false, false),
    securityGroup: secGroups.CONTENT_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.APPLICATION_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, false, false),
    securityGroup: secGroups.USERSTORE_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.VIEW_SECURITY_GROUP,
  },
]

// Section owner
const appPrivilegeHigh: IPermission[] = [
  {
    permissionLevel: createPermissionLevel(true, false, false),
    securityGroup: secGroups.METADATA_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.CONTENT_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.APPLICATION_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.USERSTORE_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.VIEW_SECURITY_GROUP,
  },
]

// section chief, MPF Leadership
const appPrivilegeMedium: IPermission[] = [
  {
    permissionLevel: createPermissionLevel(true, false, false),
    securityGroup: secGroups.METADATA_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.CONTENT_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.APPLICATION_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, false, false),
    securityGroup: secGroups.USERSTORE_SECURITY_GROUP,
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.VIEW_SECURITY_GROUP,
  },
]

// function to create Roles using Sample Roles Json
export async function CreateCPTSRoles(data: any): Promise<void> {
  for (const item of data) {
    const roleName = item?.name.trim()
    const roleCode = item?.roleCode.trim()
    const roleOwnerSplit = item?.owners.split(',')
    const roleOwner: any = []
    for (const ele of roleOwnerSplit) {
      roleOwner.push(ele.trim())
    }
    const rolepermission = item?.permissions
    await DeleteAndInsertRole(
      roleName,
      roleOwner,
      ReturnRolePermission(rolepermission),
      item?.type,
      roleCode
    )
  }
}

export async function RegAFCreateOrUpdateRoles(): Promise<void> {
  await CreateCPTSRoles(CPTSRoles)
}

//function to Create Specific Role
export async function DeleteAndInsertRole(
  roleName: string,
  roleOwner: any,
  rolePermission: any,
  roleType: string,
  roleCode: string
): Promise<void> {
  const roleObject: IRole = {
    name: roleName,
    owners: roleOwner,
    permissions: rolePermission,
    roleCode: roleCode,
    type: roleType,
  }

  try {
    const roleExist: IRole = await mpfAuthCrudHttp().GetRoleByName(roleName)
    if (roleExist) {
      await DeleteRole(roleExist.name)
      await mpfAuthCrudHttp().AddOrUpdateRole(roleObject)
    }
  } catch (e) {
    if (e && e.name.includes('NotFound')) {
      // Ignore as we are creating new list
      await mpfAuthCrudHttp().AddOrUpdateRole(roleObject)
    } else throw e
  }
}

//function to delete the Role
export async function DeleteRole(roleName: string) {
  try {
    const roleExist: IRole = await mpfAuthCrudHttp().GetRoleByName(roleName)
    if (roleExist) {
      const Id: string = roleExist?.roleId as string
      const eTag: string = roleExist?.eTag as string
      await mpfAuthCrudHttp().DeleteRole(Id, eTag)
    }
  } catch (error) {
    //Ignore
  }
}

//function to get RoleDetails by RoleName
export async function GetRolesDetails(rolename: string): Promise<void> {
  await mpfAuthCrudHttp().GetRoleByName(rolename)
}
